import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const businessappListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fbusinessapp%2Fsafety-choose-spot.png?alt=media&token=1066bf6d-059e-4770-bc84-709a93ce8a30",
  title: "Business App",
  subtitle: "Visibilty for Every Team Member",
  page: WildNavigationType.BUSINESSAPP,
}